module.exports = __webpack_public_path__ + "static/testimonial-1-4be9a2c11e486deffe38cbceac1e2d58.png";